import { useTheme } from '@emotion/react';
import { Typography } from '@mui/material';
import React from 'react';
import TypographyWithHighlightMentions from '../utils/common/TypographyWithHighlightMentions.jsx';

const Note = ({ note, expanded, isLastNote }) => {
  const theme = useTheme();

  if (!note) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em',
        margin: '0.25em 0 ',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div>
          {isLastNote && (
            <Typography
              component={'span'}
              sx={{
                whiteSpace: 'break-spaces',
                fontSize: '0.9em',
                fontWeight: '600',
                color: theme.palette.text.primary,
                marginRight: '0.5em',
              }}
            >
              Dernière note
            </Typography>
          )}
          <Typography
            component={'span'}
            sx={{
              whiteSpace: 'break-spaces',
              fontSize: '0.9em',
              fontWeight: '600',
            }}
          >
            {note?.user?.firstName + ' ' + note?.user?.lastName}
          </Typography>
        </div>
        <Typography
          component={'span'}
          sx={{
            whiteSpace: 'break-spaces',
            fontSize: '0.9em',
            fontWeight: '600',
          }}
        >
          {new Date(note?.date).toLocaleString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
          })}
        </Typography>
      </div>
      <TypographyWithHighlightMentions
        text={note?.content}
        sx={[
          {
            whiteSpace: 'break-spaces',
            fontSize: '1em',
            maxHeight: expanded ? 'none' : '8em',
            overflowY: expanded ? 'hidden' : 'auto',
          },
        ]}
      />
    </div>
  );
};

export default Note;
